<template>
  <div>
    <div v-if="!withAddAutomaticSentences">
      <form>
        <VTextarea
          v-model="sentence"
          :label="$t('forms.labels.note')"
          :rules="{ min: 1, max: 1000 }"
          @change="updateData"
        />
      </form>
    </div>
    <div
      v-else
      class="content"
    >
      <v-col cols="8">
        <p class="modalXMargin titleModal">
          {{ $t('forms.labels.automaticSentences') }}
        </p>
        <VSelect
          v-model="selectedCategory"
          outlined
          itemValue="id"
          :items="categories"
          :label="$t('forms.labels.category')"
          :loading="loadingCategories"
          @change="onChangeCategory"
        />
        <VAutocomplete
          :disabled="!selectedCategory"
          outlined
          :items="displayedSentences"
          :label="$t('forms.labels.automaticSentences')"
          :loading="loadingSentences"
          @change="onChangeSentence"
        />
        <p class="modalXMargin titleModal">
          {{ $t('forms.labels.comment') }}
        </p>
        <VTextarea
          v-model="sentence"
          outlined
          :value="sentence"
          :label="$t('automaticSentences.chosenSentence')"
          @change="updateData"
        />
      </v-col>
    </div>
  </div>
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        VAutocomplete,
        VSelect,
        VTextarea,
    },
    props: {
        note: {
            type: String,
            default: '',
        },
        withAddAutomaticSentences: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            categories: [],
            loadingCategories: true,
            loadingSentences: false,
            selectedCategory: null,
            sentence: null,
            sentences: [],
        };
    },

    computed: {
        ...mapGetters([
            'userLang', 'siteLang', 'teamMainLang',
        ]),
        displayedSentences() {
            if (this.sentences) {
                return this.sentences.map(s => ({ id: s.id, name: s.title[this.userLang] || s.title[this.teamMainLang] }));
            }
            return [];
        },
    },

    async created() {
        await this.getCategories();
        this.getSentence();
    },
    methods: {
        async getCategories() {
            const { data } = await this.$rq.getSentenceCategories({ pagination: false });
            this.categories = data.categories.map(cat => ({ ...cat, name: cat.name[this.userLang] || cat.name[this.teamMainLang] }));
            this.loadingCategories = false;
        },
        async getSentences(categoryId) {
            this.loadingSentences = true;
            const { data } = await this.$rq.getAutomaticSentences({ categoryId });
            this.sentences = data.sentences || [];
            this.loadingSentences = false;
        },
        async onChangeCategory(value) {
            await this.getSentences(value);
        },
        onChangeSentence(value) {
            const found = this.sentences.find(({ id }) => id === value);
            if (found) {
                this.sentence = found.sentence[this.siteLang];
                this.updateData();
            }
        },
        updateData() {
            this.$emit('sendData', this.sentence);
        },
        getSentence() {
            if (this.note) this.sentence = this.note;
        },
    },
};
</script>

<style lang="scss" scoped>
    .content {
        display: flex;
        flex-direction: column;
        align-items: center
    }
    .modalXMargin {
        margin-left: 0;
        margin-right: 0;
    }
</style>
